// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.card[data-v-f3342a52] {
  transition: border-color var(--document-time) ease-in-out;
}
.image[data-v-f3342a52] {
  display: block;
}
.label[data-v-f3342a52] {
  font-family: var(--primary-font);
  color: var(--text-contrast-color);
  display: block;
  transition: color var(--document-time) ease-in-out;
}
@media screen and (min-width: 38.0625rem) {
.card[data-v-f3342a52] {
    display: flex;
    flex-direction: column;
    width: 29%;
    min-width: 16rem;
    border: 3px solid var(--document-color);
    border-radius: 0.5rem;
    margin: 1rem;
}
.card[data-v-f3342a52]:hover {
    --document-color: var(--document-color-hover);
}
.image[data-v-f3342a52] {
    width: 100%;
    padding: 15% 20% 0% 20%;
}
.label[data-v-f3342a52] {
    font-size: 1.5rem;
    text-align: center;
    padding-bottom: 5%;
    margin: auto 1rem;
    overflow-wrap: anywhere;
}
.card:hover .label[data-v-f3342a52] {
    color: var(--document-color);
}
}
@media screen and (max-width: 38rem) {
.card[data-v-f3342a52] {
    display: flex;
    width: 100%;
    border: 1px solid var(--document-color);
    padding: 1.5rem 1rem;
    margin-bottom: -1px;
}
.card[data-v-f3342a52]:hover {
    z-index: 1;
}
.image[data-v-f3342a52] {
    min-width: 8rem;
    min-height: 7rem;
    padding: 0.5rem 1rem;
    width: 0;
}
.label[data-v-f3342a52] {
    font-size: clamp(1rem, 5vw, 1.5rem);
    margin-top: auto;
    overflow-wrap: anywhere;
    margin-bottom: auto;
}
.document-card .image[data-v-f3342a52] {
    min-width: 5rem;
    min-height: 5rem;
    padding: 0;
    margin-right: 1.5rem;
    width: 0;
}
}
`, "",{"version":3,"sources":["webpack://./src/components/partials/Card.vue"],"names":[],"mappings":";AAkBA;EACA,yDAAA;AACA;AAEA;EACA,cAAA;AACA;AAEA;EACA,gCAAA;EACA,iCAAA;EACA,cAAA;EACA,kDAAA;AACA;AAEA;AACA;IACA,aAAA;IACA,sBAAA;IACA,UAAA;IACA,gBAAA;IACA,uCAAA;IACA,qBAAA;IACA,YAAA;AACA;AAEA;IACA,6CAAA;AACA;AAEA;IACA,WAAA;IACA,uBAAA;AACA;AAEA;IACA,iBAAA;IACA,kBAAA;IACA,kBAAA;IACA,iBAAA;IACA,uBAAA;AACA;AAEA;IACA,4BAAA;AACA;AACA;AAEA;AACA;IACA,aAAA;IACA,WAAA;IACA,uCAAA;IACA,oBAAA;IACA,mBAAA;AACA;AAEA;IACA,UAAA;AACA;AAEA;IACA,eAAA;IACA,gBAAA;IACA,oBAAA;IACA,QAAA;AACA;AAEA;IACA,mCAAA;IACA,gBAAA;IACA,uBAAA;IACA,mBAAA;AACA;AAEA;IACA,eAAA;IACA,gBAAA;IACA,UAAA;IACA,oBAAA;IACA,QAAA;AACA;AACA","sourcesContent":["<template>\n  <a class=\"card\" :title=\"label\" @click=\"$emit('click')\">\n    <i class=\"image\">\n      <slot />\n    </i>\n    <span class=\"label\">{{ label }}</span>\n  </a>\n</template>\n\n<script>\nexport default {\n  props: {\n    label: { type: String, default: undefined }\n  }\n}\n</script>\n\n<style scoped>\n.card {\n  transition: border-color var(--document-time) ease-in-out;\n}\n\n.image {\n  display: block;\n}\n\n.label {\n  font-family: var(--primary-font);\n  color: var(--text-contrast-color);\n  display: block;\n  transition: color var(--document-time) ease-in-out;\n}\n\n@media screen and (min-width: 38.0625rem) {\n  .card {\n    display: flex;\n    flex-direction: column;\n    width: 29%;\n    min-width: 16rem;\n    border: 3px solid var(--document-color);\n    border-radius: 0.5rem;\n    margin: 1rem;\n  }\n\n  .card:hover {\n    --document-color: var(--document-color-hover);\n  }\n\n  .image {\n    width: 100%;\n    padding: 15% 20% 0% 20%;\n  }\n\n  .label {\n    font-size: 1.5rem;\n    text-align: center;\n    padding-bottom: 5%;\n    margin: auto 1rem;\n    overflow-wrap: anywhere;\n  }\n\n  .card:hover .label {\n    color: var(--document-color);\n  }\n}\n\n@media screen and (max-width: 38rem) {\n  .card {\n    display: flex;\n    width: 100%;\n    border: 1px solid var(--document-color);\n    padding: 1.5rem 1rem;\n    margin-bottom: -1px;\n  }\n\n  .card:hover {\n    z-index: 1;\n  }\n\n  .image {\n    min-width: 8rem;\n    min-height: 7rem;\n    padding: 0.5rem 1rem;\n    width: 0;\n  }\n\n  .label {\n    font-size: clamp(1rem, 5vw, 1.5rem);\n    margin-top: auto;\n    overflow-wrap: anywhere;\n    margin-bottom: auto;\n  }\n\n  .document-card .image {\n    min-width: 5rem;\n    min-height: 5rem;\n    padding: 0;\n    margin-right: 1.5rem;\n    width: 0;\n  }\n}\n</style>\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
